import { createAsyncAction } from 'async-selector-kit'
import { API_PATH_SUBSCRIPTIONS_UPDATE } from '../../../../config'
import { RootState } from '../../../../store'
import { getApiConfig, getLocalServerURL } from '../../../../utils/getApiConfig'
import { onIsLoading } from '../../../../utils/onLoading'
import { getPortalBootstrapForce } from '../../selectors/api/bootstrap'

export type StoreLike = {
  getState: () => RootState
  dispatch: (action: unknown) => void
}

/**
 * Core subscription update logic. Exported for testing (success, error, config null).
 */
export async function executeUpdateSubscription(
  store: StoreLike,
  model: {
    subscriptionId: string
    description: string
    skipBootstrap?: boolean
  }
): Promise<void> {
  const PATH = getLocalServerURL(API_PATH_SUBSCRIPTIONS_UPDATE)
  onIsLoading(true)
  try {
    const { skipBootstrap, ...requestBody } = model
    const config = await getApiConfig({ body: requestBody })
    if (config == null) {
      throw new Error('Could not authorize subscription update')
    }
    const response = await fetch(PATH, config)
    if (!response.ok) {
      throw new Error('Failed to update subscription')
    }
    const data = await response.json()
    if (data?.messages?.resultCode === 'Ok') {
      if (!skipBootstrap) {
        await getPortalBootstrapForce(store.getState() as RootState)
      }
      return
    }
    const error = data?.messages?.message?.[0]?.text || 'Unknown error'
    throw new Error(error)
  } finally {
    onIsLoading(false)
  }
}

export const [updateSubscription, _, updateSubscriptionError] =
  createAsyncAction(
    {
      id: 'update-subscription',
      async:
        (store) =>
        async (model: {
          subscriptionId: string
          description: string
          skipBootstrap?: boolean
        }) => {
          await executeUpdateSubscription(store, model)
        },
    },
    []
  )
